import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { DownloadService } from "../../services/download.service";
import { FileService } from "../../services/file.service";
import { LoaderService } from "../../services/loader.service";
import { SnackbarService } from "../../services/snackbar.service";
import { Receivable } from "../../model/domain/Receivable";
import { TabelaHistoricoCargaService } from "../../services/tabela-historico-carga.service";
import { faDownload, faTrash } from "@fortawesome/free-solid-svg-icons";
import { DomainService, LoadType } from "../../services/domain.service";
import { UploadCarga } from "../../model/domain/UploadCarga";
import { LoadHistory } from "../../model/domain/LoadHistory";

@Component({
  selector: "tabela-historico-carga",
  templateUrl: "./tabela-historico-carga.component.html",
  styleUrls: ["./tabela-historico-carga.component.css"],
})
export class TabelaHistoricoCargaComponent implements OnInit {
  constructor(
    private downloadService: DownloadService,
    private fileService: FileService,
    private loaderService: LoaderService,
    private snackBarService: SnackbarService,
    private domainService: DomainService,
    private tabelaHistoricoCargaService: TabelaHistoricoCargaService,
    private datePipe: DatePipe
  ) {}

  displayedColumns = [
    "FileName",
    "UserName",
    "CreationDate",
    "LoadType",
    "TriggerTypeName",
  ];

  Hoje: Date = new Date();
  starDate: Date = new Date(
    this.Hoje.getFullYear(),
    this.Hoje.getMonth(),
    this.Hoje.getDate()
  );
  endDate: Date = new Date(
    this.Hoje.getFullYear(),
    this.Hoje.getMonth(),
    this.Hoje.getDate()
  );

  dataSource: LoadHistory[] = null;

  defaultPage = 1;
  currentPage = 1;
  defaultSize = 10;
  totalPages: number = null;
  totalItems: number = null;
  listedPages = [];
  firstItemOnPage: number;
  lastItemOnPage: number;
  faDownload = faDownload;
  model: UploadCarga;
  loadTypeFilter: number;
  triggerTypeFilter: number;
  LoadType: LoadType[];

  LoadTypes: LoadType[];
  loads = {
    1: "Fundos (Amplis)",
    2: "Gestores (Amplis)",
    3: "Contas de Fundos (Amplis)",
    4: "Fundos Investidos (Amplis)",
    6: "Lastros (Amplis)",
    7: "Fundos (JCOT)",
    8: "Cotistas (JCOT)",
    10: "Estoque de Fundos (Amplis)",
    11: "Estoque de Renda Fixa (Amplis)",
    12: "Estoque de Renda Variável (Amplis)",
  };

  ngOnInit(): void {
    this.getHistory();
    this.domainService.ListLoadTypes().subscribe((types) => {
      types.sort(function (a: any, b: any) {
        return a.name > b.name ? 1 : -1;
      });
      this.LoadTypes = types;
    });
  }

  download(name: string) {
    const download = this.fileService.download(name);

    return download.subscribe(
      (data: Blob) => {
        this.downloadService.downloadFile(data, name);

        this.loaderService.removeLoader();
      },
      () => {
        this.loaderService.removeLoader();

        this.snackBarService.open(
          "Não foi possível fazer o download do arquivo.",
          "OK"
        );
      }
    );
  }

  periodoError() {
    if (this.endDate == null || this.starDate == null) {
      return true;
    }
    const dateDiff =
      (this.endDate.getTime() - this.starDate.getTime()) / 86400000;
    return dateDiff > 30 || dateDiff < 0;
  }

  getHistory(
    page: number = this.defaultPage,
    pageSize: number = this.defaultSize
  ) {
    const params: any[] = [
      this.loadTypeFilter,
      this.triggerTypeFilter,
      this.starDate,
      this.endDate,
      page,
      pageSize,
    ];

    this.tabelaHistoricoCargaService.GetFiles(...params).subscribe((s) => {
      const rows = [];
      s.results.forEach((element) => {
        element.loadType = this.loads[element.loadType];
        rows.push(element);
      });

      this.dataSource = rows;
      this.totalPages = s.pageCount;
      this.totalItems = s.rowCount;
      this.firstItemOnPage = s.firstRowOnPage;
      this.lastItemOnPage = s.lastRowOnPage;
      this.currentPage = s.currentPage;
      this.listedPages = [];

      let startPage = this.currentPage - 2;
      if (startPage <= 0) {
        startPage = 1;
      }

      let maxPage = this.currentPage + 2;
      while (maxPage > this.totalPages) {
        maxPage--;
      }

      for (let i = startPage; i <= maxPage; i++) {
        this.listedPages.push(i);
      }
    });
  }
}
